import type { LogConfig, Logger } from '../../types/logging/core';
import type { WorkerCommandType, WorkerRequest } from './publisher.ts';
import { WorkerCommandExecutor } from './worker-common.ts';
import type { GatewayWorker } from '../worker/worker.ts';


// all imports except for worker should be dynamic. This way we can do preload before those imports
// (very helpful in web tests that involve workers)

async function configureLogging(worker: GatewayWorker) {
    let logLevel = worker.findParameter('logLevel');

    if (logLevel?.startsWith('"')) {
        try {
            logLevel = JSON.parse(logLevel);
        } catch (e) {
            logLevel = null;
        }
    }
    return await worker.streamLogs(logLevel as LogConfig['level'] ?? 'info');
}


function attach(worker: GatewayWorker, log: Logger) {
    const executor = new WorkerCommandExecutor(log);
    worker.onmessage = async (event: { data: WorkerRequest<keyof WorkerCommandType> }) => {
        const {id, cmd, arg} = event.data;
        try {
            await executor.execute(cmd, arg);
            worker.send({id, result: 'ok'});
        } catch (ex) {
            const {serializeError} = await import('serialize-error');
            const error = serializeError(ex);
            worker.send({id, error});
        }
    };
}

import('../worker/worker.ts')
    .then((module) => module.default)
    .then(async (worker) => {
            const logging = await configureLogging(worker)
            const log = logging.getLogger('gateway.metrics.worker');
            attach(worker, log);
            worker.send({ready: true});
        }
    ).catch(e => console.error(e));
